import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';

import PaymentIcons from './PaymentIcons';
import { $cartState } from '../../../store/models/cart';
import { Frequency } from '../../../model/enums';
import { $productsState } from '../../../store/models/products';
import { formatFrequency, upperWord } from '../../../helpers/functions';

import styles from './styles.module.scss';

const CheckoutAside = () => {
  const { 
    selectedProductSize, 
    selectedProduct, 
    selectedProductFrequency,
    isSelectedAccessory 
  } = useUnit($cartState);
  const { accessories } = useUnit($productsState);

  const { t } = useTranslation();
  let price = selectedProductSize
    ? selectedProductFrequency === Frequency.Once
      ? selectedProduct?.actual_price
      : selectedProduct?.subscribe_price
    : 0;

  const selectedAccessory = accessories.find(ac => ac.size === selectedProductSize);

  // The tray comes in both sizes — bill whichever one matches the chosen grass.
  if (isSelectedAccessory && selectedAccessory) {
    // @ts-ignore
    price += selectedAccessory.price;
  }

  return (
    <div className={styles.checkoutAside}>
      <div className={styles.content}>
        <h3>{t('yourFreshPatchSummary')}</h3>
        <div className={`${styles.item} ${!selectedProductSize ? styles.unselect : ''}`}>
          <p>{t('size')}</p>
          <p>
            {selectedProductSize ? upperWord(selectedProduct?.size || '') : '--'}
          </p>
        </div>
        <div
          className={`${styles.item} ${
            !selectedProductFrequency ? styles.unselect : ''
          }`}
        >
          <p>{t('frequency')}</p>
          <p className={styles.accessoryCartRight}>{formatFrequency(t, selectedProductFrequency) || '--'}</p>
        </div>
        <div className={`${styles.item} ${!isSelectedAccessory ? styles.unselect : ""}`}>
          <p>{t("accessory")}</p>
          <p className={styles.accessoryCartRight}>{isSelectedAccessory ? t("plasticTray") : t("notAdded")}</p>
        </div>
        <div className={styles.paymantWrapper}>
          <div className={styles.weeklyTotal}>
            <p>{t('payEvery2Weeks')}</p>
            <p>€{selectedProductSize ? selectedProduct?.subscribe_price : 0}</p>
          </div>
          <div className={styles.total}>
            <p>{t('totalToPayToday')}</p>
            <p>€{price}</p>
          </div>
        </div>
      </div>
      <div className={styles.iconsWrapper}>
        <p>{t('securePaymentsBy')}</p>
        <PaymentIcons />
      </div>
    </div>
  );
};

export default CheckoutAside;
